import { getBuyerDisplayName } from "../utils/buyerName";
import React from "react";
import "./app-layout.css";
import dworksWordmark from "../assets/dworks-wordmark.png";

function BuyerWordmark(){
  return <span className="app-buyer-wordmark" role="img" aria-label="D-Works" style={{maskImage:`url(${dworksWordmark})`,WebkitMaskImage:`url(${dworksWordmark})`}}/>;
}

function MenuIcon({ name }) {
  const paths = {
    more: <><circle cx="5" cy="12" r="1"/><circle cx="12" cy="12" r="1"/><circle cx="19" cy="12" r="1"/></>,
    "product-create": <><path d="M4 5h10v16H4zM7 9h4M7 13h4M18 3v8M14 7h8"/></>,
    dash: (
      <>
        <rect x="3" y="3" width="7" height="7" rx="2" />
        <rect x="14" y="3" width="7" height="7" rx="2" />
        <rect x="3" y="14" width="7" height="7" rx="2" />
        <rect x="14" y="14" width="7" height="7" rx="2" />
      </>
    ),
    order: (
      <>
        <path d="M6 5h12v16H6z" />
        <path d="M9 3h6v4H9zM12 11v6M9 14h6" />
      </>
    ),
    prods: (
      <>
        <path d="m12 3 8 4-8 4-8-4 8-4Z" />
        <path d="m4 12 8 4 8-4M4 17l8 4 8-4" />
      </>
    ),
    list: (
      <>
        <path d="M6 3h9l3 3v15H6zM14 3v4h4" />
        <path d="M9 11h6M9 15h6" />
      </>
    ),
    chat: (
      <>
        <path d="M21 15a4 4 0 0 1-4 4H8l-5 3V7a4 4 0 0 1 4-4h10a4 4 0 0 1 4 4z" />
        <path d="M8 9h8M8 13h5" />
      </>
    ),
    inventory: (
      <>
        <path d="m4 7 8-4 8 4-8 4-8-4Z" />
        <path d="M4 7v10l8 4 8-4V7M12 11v10" />
      </>
    ),
    vendors: (
      <>
        <circle cx="9" cy="8" r="3" />
        <path d="M3.5 20a5.5 5.5 0 0 1 11 0M16 6a3 3 0 0 1 0 6M17 15a5 5 0 0 1 3.5 5" />
      </>
    ),
    settings: (
      <>
        <circle cx="12" cy="12" r="3" />
        <path d="M19 12a7 7 0 0 0-.1-1l2-1.5-2-3.4-2.4 1a8 8 0 0 0-1.8-1L14.4 3h-4.8l-.3 3.1a8 8 0 0 0-1.8 1l-2.4-1-2 3.4 2 1.5a7 7 0 0 0 0 2l-2 1.5 2 3.4 2.4-1a8 8 0 0 0 1.8 1l.3 3.1h4.8l.3-3.1a8 8 0 0 0 1.8-1l2.4 1 2-3.4-2-1.5a7 7 0 0 0 .1-1Z" />
      </>
    ),
  };

  return (
    <svg
      className="app-sidebar__icon"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.7"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      {paths[name] || paths.dash}
    </svg>
  );
}

function BellIcon() {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <path d="M18 8a6 6 0 0 0-12 0c0 7-3 7-3 9h18c0-2-3-2-3-9" />
      <path d="M10 21h4" />
    </svg>
  );
}

function LogoutIcon() {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <path d="M10 4H5v16h5" />
      <path d="M14 8l4 4-4 4M8 12h10" />
    </svg>
  );
}

export function LeftMenu({
  buyer = false,
  items,
  bottomItems,
  activePage,
  onNavigate,
  onLogoClick,
  user,
  unreadCount,
  onNotifications,
  footerAriaLabel = "알림 페이지로 이동",
  footerIcon = "notification",
}) {
  const profileName = buyer ? getBuyerDisplayName(user?.name) : user?.company || "디자인워커스";
  const isLogoutFooter = footerIcon === "logout";

  return (
    <aside className="app-sidebar">
      <button className="app-sidebar__logo" type="button" onClick={onLogoClick}>
        {buyer ? <BuyerWordmark/> : <span className="app-sidebar__logo-copy">
          <strong>D-Work<em>s</em></strong>
          <small>DESIGN WALKERS</small>
        </span>}
      </button>

      {(bottomItems?[{menuItems:items,mobile:false},{menuItems:bottomItems,mobile:true}]:[{menuItems:items,mobile:false}]).map(({menuItems,mobile})=>(
      <nav className={`app-sidebar__menu ${mobile?"app-sidebar__menu--mobile":bottomItems?"app-sidebar__menu--desktop":""}`} aria-label={mobile?"하단 메뉴":"주 메뉴"} key={mobile?"mobile":"desktop"}>
        {menuItems.map((item) => (
          <button
            className={`app-sidebar__menu-item${item.key === "more" ? " app-sidebar__menu-item--more" : ""}`}
            type="button"
            key={item.key}
            aria-current={activePage === item.key ? "page" : undefined}
            onClick={() => item.onClick ? item.onClick() : onNavigate(item.key)}
          >
            <span className="app-sidebar__icon-wrap" style={{ position: "relative" }}>
              <MenuIcon name={item.icon || item.key} />
              {Number(item.badgeCount || 0) > 0 && (
                <span
                  className="app-sidebar__menu-badge"
                  aria-label={`${item.label} 확인 필요 ${Number(item.badgeCount || 0)}건`}
                  style={{
                    minWidth: 20,
                    height: 20,
                    padding: "0 6px",
                    borderRadius: 999,
                    display: "inline-flex",
                    alignItems: "center",
                    justifyContent: "center",
                    position: "absolute",
                    top: -9,
                    right: -12,
                    zIndex: 2,
                    margin: 0,
                    background: "#d92d20",
                    color: "#fff",
                    fontSize: 11,
                    fontWeight: 800,
                    textAlign: "center",
                    lineHeight: 1,
                    pointerEvents: "none",
                  }}
                >
                  {Number(item.badgeCount || 0) > 99 ? "99+" : Number(item.badgeCount || 0)}
                </span>
              )}
            </span>
            <span className="app-sidebar__label">{item.label}</span>
            <svg className="app-sidebar__arrow" width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
              <path d="M5 12h14M13 6l6 6-6 6" />
            </svg>
          </button>
        ))}
      </nav>
      ))}

      <button
        className={`app-sidebar__footer${isLogoutFooter ? " app-sidebar__footer--logout" : ""}`}
        type="button"
        onClick={onNotifications}
        aria-label={footerAriaLabel}
      >
        {isLogoutFooter && (
          <span className="app-sidebar__profile">
            <span className="app-sidebar__profile-copy">
              <strong>{profileName}</strong>
              <small>{user?.email || "D-Works 계정"}</small>
            </span>
          </span>
        )}

        <span className="app-sidebar__notification">
          {isLogoutFooter ? <LogoutIcon /> : <BellIcon />}
          {unreadCount > 0 && (
            <span className="app-sidebar__notification-count">
              {unreadCount > 99 ? "99+" : unreadCount}
            </span>
          )}
        </span>

        {!isLogoutFooter && (
          <span className="app-sidebar__profile">
            <span className="app-sidebar__profile-copy">
              <strong>{profileName}</strong>
              <small>{user?.email || "D-Works 계정"}</small>
            </span>
          </span>
        )}
      </button>
    </aside>
  );
}

function AppLayoutContent({
  items,
  bottomItems,
  activePage,
  onNavigate,
  onLogoClick,
  user,
  unreadCount = 0,
  onNotifications,
  onSettings,
  footerAriaLabel = "알림 페이지로 이동",
  footerIcon = "notification",
  children,
  buyer = false,
  actualPage = activePage,
  headerActions,
}) {
  const isLogoutFooter = footerIcon === "logout";

  return (
    <div className={`app-layout${buyer ? " app-layout--buyer" : ""}${buyer && !["dash", "more"].includes(actualPage) ? " app-layout--no-bottom-nav" : ""}`}>
      <header className="app-mobile-header">
        <button className="app-mobile-header__logo" type="button" onClick={onLogoClick}>
          {buyer ? <BuyerWordmark/> : "D-Works"}
        </button>
        <button className="app-mobile-header__notification" type="button" onClick={onNotifications} aria-label={footerAriaLabel}>
          {isLogoutFooter ? <LogoutIcon /> : <BellIcon />}
          {!isLogoutFooter && unreadCount > 0 && (
            <span className="app-mobile-header__notification-count">
              {unreadCount > 99 ? "99+" : unreadCount}
            </span>
          )}
        </button>
        {buyer && actualPage === "more" && <button className="app-mobile-header__settings" type="button" aria-label="설정" onClick={()=>onSettings ? onSettings() : onNavigate?.("settings")}><MenuIcon name="settings"/></button>}

      </header>

      {buyer && headerActions && <div className="app-header-actions">{headerActions}</div>}
      <LeftMenu
        buyer={buyer}
        items={items}
        bottomItems={bottomItems}
        activePage={activePage}
        onNavigate={onNavigate}
        onLogoClick={onLogoClick}
        user={user}
        unreadCount={unreadCount}
        onNotifications={onNotifications}
        footerAriaLabel={footerAriaLabel}
        footerIcon={footerIcon}
      />
      <main className="app-content">{children}</main>
    </div>
  );
}

export default function AppLayout(props) {
  return <AppLayoutContent {...props}/>;
}
